import { render, staticRenderFns } from "./ProofreadsSummary.vue?vue&type=template&id=4fe940ae&scoped=true&"
import script from "./ProofreadsSummary.vue?vue&type=script&lang=ts&"
export * from "./ProofreadsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ProofreadsSummary.vue?vue&type=style&index=0&id=4fe940ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe940ae",
  null
  
)

export default component.exports